/** think_fold_mode 过渡协议：下线 agent 时随 thinkFoldAgent 目录一并删除 */

export type TThinkFoldMode = 'tool' | 'agent';

export const THINK_FOLD_MODE_ITEM_TYPE = 'think_fold_mode';

export const getThinkFoldModeFromValue = (
  thinkValue?: Array<{ type?: string; value?: unknown; }>,
): TThinkFoldMode => {
  const mode = thinkValue?.find(item => item?.type === THINK_FOLD_MODE_ITEM_TYPE)?.value;
  return mode === 'tool' ? 'tool' : 'agent';
};

export const getHistoryFoldMode = (
  answerParts: Array<{ type?: string; data?: { type?: string; value?: string; }; }>,
): TThinkFoldMode => {
  const foldPart = answerParts.find(
    part => part?.type === 'data' && part?.data?.type === THINK_FOLD_MODE_ITEM_TYPE,
  );
  return foldPart?.data?.value === 'tool' ? 'tool' : 'agent';
};

export const isAgentFoldMode = (mode: TThinkFoldMode): boolean => mode !== 'tool';
